<template>
    <v-tooltip
        v-if="showButtonTooltip"
        :text="tooltipText"
        location="top"
        content-class="custom-tooltip"
    >
        <template #activator="{ props }">
            <button
                :class="btnStyle"
                @click="executeMethod"
                :type="type"
                :disabled="isDisabled"
                v-bind="props"
                :data-cy="dataCy"
            >
                <span v-if="btnLoading">
                    <div class="lds-dual-ring"></div>
                </span>
                <span v-else :class="textStyle">
                    {{ text }}
                </span>
            </button>
        </template>
    </v-tooltip>

    <button
        v-else
        :class="btnStyle"
        @click="executeMethod"
        :type="type"
        :disabled="isDisabled"
        :data-cy="dataCy"
    >
        <span class="btn-content-wrapper">
            <!-- Keep text for width but hide it when loading -->
            <span
                :class="textStyle"
                :style="{ visibility: btnLoading ? 'hidden' : 'visible' }"
            >
                {{ text }}
            </span>
            <!-- Absolutely position the loader so it doesn't affect width -->
            <div
                v-if="btnLoading"
                class="lds-dual-ring"
                style="position: absolute"
            ></div>
        </span>
    </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

const componentProps = defineProps<{
    btnStyle?: string;
    text?: string;
    textStyle?: string;
    disabled?: boolean;
    btnLoading?: boolean;
    type?: any;
    isDisabled?: boolean;
    showTooltip?: boolean;
    tooltipMessage?: string;
    dataCy?: string;
}>();

const showButtonTooltip = computed(() => componentProps.showTooltip ?? false);
const tooltipText = computed(
    () =>
        componentProps.tooltipMessage ??
        "You do not have permission to perform this action.",
);

const emit = defineEmits(["runMethod"]);
const executeMethod = () => {
    emit("runMethod");
};
</script>

<style scoped>
/** Changes Vuetify's v-tooltip settings */
:global(.custom-tooltip) {
    opacity: 1 !important;
    background-color: #3d3e4d !important;
    border: 1px solid #9394a9 !important;
    color: #ffffff !important;
    transform: translate(-0.7rem -0.8rem);
}
</style>
